module.exports = __webpack_public_path__ + "static/img/scene04.305d50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene04.png
// module id = oDOR
// module chunks = 1